import { ReactNode } from 'react';

export interface ConditionalWrapProps<TChildren = ReactNode> {
  /**
   * True if children should be wrapped
   */
  condition: boolean;

  /**
   * Function called when wrapping should be performed
   */
  wrap(children: TChildren): TChildren;

  children: TChildren;
}

/**
 * Usable when a component parent is decided based on a condition, e.g
 * only display a Tooltip on certain elements.
 */
export const ConditionalWrap = <TChildren extends React.JSX.Element>(
  props: ConditionalWrapProps<TChildren>,
) => {
  return <>{props.condition ? props.wrap(props.children) : props.children}</>;
};
